import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuestionLibraryTab } from '@/views/admin/courses/tabs/question-library-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/questions')({
  component: QuestionsRoute,
});

function QuestionsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/questions' });
  return <QuestionLibraryTab id={id} />;
}
